import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    IconButton,
    Drawer,
    Container,
    Stack
} from '@mui/material';
import { Menu } from '@mui/icons-material';

import './navbar.scss';
import { PRISPEK } from '../../assets';
import { Theme } from '../../config';
import { useEvents } from '../../context';
import { useWindowDimensions } from '../../hooks';
import { NavbarProps, NavbarLinks } from '..';

export const Navbar: React.FC<NavbarProps> = React.memo(
    ({ landing, about, services, blog, contact, login }) => {
        const { width } = useWindowDimensions();
        const { reset } = useEvents();
        const [mobileOpen, setMobileOpen] = useState<boolean>(false);
        const [offset, setOffset] = useState(0);

        useEffect(() => {
            window.onscroll = () => setOffset(window.pageYOffset);
            window.onload = () => setOffset(window.pageYOffset);
        }, []);

        const handleDrawerToggle = useCallback(() => {
            setMobileOpen(prevMobileOpen => !prevMobileOpen);
        }, []);

        return (
            <AppBar
                position='fixed'
                className='navbar'
                style={{
                    background:
                        // eslint-disable-next-line no-restricted-globals
                        offset > screen.height - 200 || !landing
                            ? 'rgb(277, 277, 277)'
                            : 'rgba(277, 277, 277, 0.7)'
                }}
                elevation={0}
            >
                <Container maxWidth='xl'>
                    <Stack direction='row'>
                        <Toolbar disableGutters style={{ width: '100%' }}>
                            <Link to='/' className='navbar__logo'>
                                <img src={PRISPEK} alt='Prispek Logo' />
                            </Link>
                        </Toolbar>
                        <Toolbar disableGutters>
                            {width > 858 ? (
                                <NavbarLinks
                                    reset={reset}
                                    lightYellow={Theme.lightYellow}
                                    landing={landing}
                                    about={about}
                                    services={services}
                                    blog={blog}
                                    contact={contact}
                                    login={login}
                                />
                            ) : (
                                <IconButton
                                    color='primary'
                                    aria-label='open drawer'
                                    edge='end'
                                    onClick={handleDrawerToggle}
                                >
                                    <Menu />
                                </IconButton>
                            )}
                        </Toolbar>
                    </Stack>
                </Container>
                <Drawer
                    variant='temporary'
                    anchor='right'
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true
                    }}
                    sx={{ minWidth: '15rem' }}
                >
                    <div style={{ flex: 1 }}></div>
                    <NavbarLinks
                        reset={reset}
                        drawer
                        lightYellow={Theme.lightYellow}
                        landing={landing}
                        about={about}
                        services={services}
                        blog={blog}
                        contact={contact}
                        login={login}
                    />
                </Drawer>
            </AppBar>
        );
    }
);
